import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/app.settings';
import { TreatmentEntity } from 'src/app/core/interfaces/treatment-entity';
import { PriceListCode } from 'src/app/core/models/price-list-code';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import { SearchCustomerService } from 'src/app/core/services/search-customer.service';
import { StandbyService } from '../../standby/standby.service';
import { SchedulerService } from '../scheduler.service';
import { FindTimeService } from 'src/app/core/services/find-time.service';
import { ScopeService } from 'src/app/core/services/scope.service';
import { AppData } from 'src/app/app.data';
import { Router } from '@angular/router';
import { Settings } from 'src/app/app.settings.model';
import { Arguments } from 'src/app/core/models/arguments';
import { ComplexBranch } from 'src/app/core/interfaces/complex-branch';
import { SchedulerModel } from 'src/app/core/models/scheduler.model';
import { Location } from '@angular/common';
import { Utils } from 'src/app/core/utils';

@Component({
  selector: 'app-treatment-selection',
  templateUrl: './treatment-selection.component.html',
  styleUrls: ['./treatment-selection.component.scss']
})
export class TreatmentSelectionComponent implements OnInit {
  
  // error: string;
   settings: Settings; 
  // loading: boolean;
  // message = '';
  // hasPermission: boolean;


   @Input() schedulers: SchedulerModel[] = [];
   @Input() branches: ComplexBranch[] = [];
   @Input() isReasonRequired= true;
   @Input() hasTreatmentsTodo= false;
   @Input() patientID?: number;
   @Input() practiceID?:number;
   //@Input() reason?: string = '';
   @Input() branchID?: any = '';
   @Input() scheduler?: any = '';
   @Input() treatments: TreatmentEntity[] = [];
   @Input() priceListCodes: PriceListCode[] = [];
   @Output() onSelectVisitReasonClick = new EventEmitter<any>();
   @Output() onClearVisitReasonClick = new EventEmitter<any>();
   @Output() onClearPriceListCodeClick = new EventEmitter<any>();
   @Output() onClearTreatmentClick = new EventEmitter<any>();
  
  constructor(
    private appSettings: AppSettings,    
    public translate: TranslateService,    
    private appData: AppData,
     private router: Router
  ) { 
      
       this.settings = appSettings.settings;    
      
    }

  ngOnInit(): void {
  }

  getTreatmentSummary(treatment: TreatmentEntity) {
    return Utils.treatmentToString(treatment, this.translate);
  }

  getPriceListSummary(priceListCode: PriceListCode) {
    return Utils.priceListCodeToString(priceListCode, this.translate);
  }

  onSelectVisitReason(feature) {   

    const args = new Arguments();
    args.CustomerID = this.patientID || 0;
    args.PracticeID = this.practiceID || 0;
    args.Branches = this.branchID ? this.branchID : this.branches.map(x => x.BranchID).toString(); // can be one or list =>   1 or 1,2,3,4
    args.Schedulers = this.scheduler ? this.scheduler : this.schedulers.map(x => x.ID).toString(); // can be one or list =>   1 or 1,2,3,4

    // pass form data to select a treatment
    this.appData.arguments = args;

    this.onSelectVisitReasonClick.emit({
      args: args,
      feature: feature
    });

    // navigate to 'select-from-pricelist' or 'select-from-card'
    //this.router.navigate([feature]);
  }

  onClearVisitReason(event: any){    
    this.onClearVisitReasonClick.emit({});
    // delete also from the component will fix issue of re rendering
    this.treatments = [];
    this.priceListCodes = [];

  }

  onClearTreatment(event: any, treatment: TreatmentEntity) {
    this.onClearTreatmentClick.emit(treatment);
    this.appData.treatments = this.treatments = this.treatments.filter(x=> x.ID !== treatment.ID);
  }

  onClearPriceListCode(event: any, priceListCode: PriceListCode) {
    this.onClearPriceListCodeClick.emit(priceListCode);
    this.appData.priceListCodes = this.priceListCodes = this.priceListCodes.filter(x=> x.ID !== priceListCode.ID);
    
  }

}
